import { PropsWithChildren, JSX, useContext } from "react";
import { ErrorMessage } from "../ErrorMessage";
import styles from "./FormField.module.css";
import classNames from "classnames";
import { useI18n } from "../../i18n";
import { AppContext, errorId, hasWarningForField, warningId } from "../../state";
export type FormFieldProps = {
  id: string;
  tracking_id?: string;
  label?: string;
  labelFor?: string;
  errorMessage?: string;
  isOptionalField?: boolean;
  className?: string;
} & PropsWithChildren;

const FormField = (props: FormFieldProps): JSX.Element => {
  const {
    children,
    id,
    tracking_id = undefined,
    label = null,
    labelFor = undefined,
    errorMessage = null,
    className = "",
    isOptionalField = false,
  } = props;

  const { t } = useI18n();
  const state = useContext(AppContext);

  const fieldClassNames = classNames(styles.formField, className);
  const hasErrorMessage = !!errorMessage;
  const hasWarningMessage = hasWarningForField(state, id);
  const describedBy = [hasErrorMessage && errorId(id), hasWarningMessage && warningId(id)].filter(Boolean).join(" ");
  return (
    <div
      className={fieldClassNames}
      id={tracking_id}
      aria-describedby={describedBy || undefined}
      aria-invalid={hasErrorMessage || hasWarningMessage}
    >
      {label !== null && (
        <label id={`${id}_label`} htmlFor={labelFor} className={styles.label} data-testid="formfieldLabel">
          {t(label)}
          {isOptionalField && <span className={styles.optional}> {t("optional")}</span>}
        </label>
      )}
      <div id={id}>{children}</div>
      {errorMessage !== null && <ErrorMessage message={errorMessage} messageReferenceId={errorId(id)} />}
    </div>
  );
};

export { FormField };
